import request from "@/utils/request";
// 储能

// 查询储能柜状态统计
export const getEnergyStorageStatusStats = params => {
	return request({
		url: "/energystorage/statusstats",
		method: "GET",
		params,
	});
};

// 实时功率统计查询
export const getEnergyLastPowerStats = params => {
	return request({
		url: "/energy/powerstats/last",
		method: "GET",
		params,
	});
};

// 查询储能柜自定义模式规则
export const getEnergyStorageCustomModePlan = params => {
	return request({
		url: "/energystorage/custommodeplan",
		method: "GET",
		params,
	});
};

// 储能柜控制
export const controlEnergyStorage = data => {
	return request({
		url: "/energystorage/control",
		method: "POST",
		data,
	});
};

// 储能桩远程操作结果
export const getControlEnergyStorageResult = params => {
	return request({
		url: "/energystorage/control/status",
		method: "GET",
		params,
	});
};
//	添加修改删除储能柜自定义模式规则

export const setEnergyStorageCustomModePlan = data => {
	return request({
		url: "/energystorage/custommodeplan",
		method: "POST",
		data,
	});
};
export const getEnergyStats = params => {
	return request({
		url: "/energystorage/stats",
		method: "GET",
    params
	});
};
//查询能源统计综合信息
export const getEnergyStatsByPeriod = params => {
	return request({
		url: "/energy/stats/period",
		method: "GET",
    params
	});
};
//	按照站点查询能源统计
export const getEnergyStatsBySite = params => {
	return request({
		url: "/energy/stats/site",
		method: "GET",
    params
	});
};
//综合统计导出
export const getEnergyStatsFileV2 = params => {
	return request({
		url: "/energy/stats/file/v2",
		method: "GET",
    params
	});
};
//功率统计查询 soc 电网 车充 光伏
export const getEnergyPowerStatsV2 = params => {
	return request({
		url: "/energy/powerstats/v2",
		method: "GET",
    params
	});
};

//soc
export const getEnergyStorageEnergyStats = params => {
	return request({
		url: "/energystorage/energystats",
		method: "GET",
    params
	});
};

export const getEnergyPowerStatsFileV2 = params => {
	return request({
		url: "/energy/powerstats/file/v2",
		method: "GET",
    params
	});
};
//SOC统计
export const getEnergyStorageFlowData = params => {
	return request({
		url: "/energyStorage/flow/data",
		method: "GET",
    params
	});
};
export const getSiteMeter = params => {
	return request({
		url: "/siteMeter",
		method: "GET",
    params
	});
};
export const getSiteMeterEnergyStats = params => {
	return request({
		url: "/siteMeter/energy/stats",
		method: "GET",
    params
	});
};
export const getSiteMeterDemandPowerStats = params => {
	return request({
		url: "/siteMeter/demandPower",
		method: "GET",
    params
	});
};
export const getPowerData = params => {
	return request({
		url: "/power/data",
		method: "GET",
    params
	});
};
// 编辑电表
export const setSiteMeter = data => {
	return request({
		url: "/siteMeter",
		method: "POST",
		data,
	});
};
// 查询PCS
export const getPcs = params => {
	return request({
		url: "/device/pcs",
		method: "GET",
    params
	});
};
// 	修改PCS
export const setPcs = data => {
	return request({
		url: "/device/pcs",
		method: "POST",
		data,
	});
};
// 	修改PCS下的储能柜名称
export const setEnergyStorage = data => {
	return request({
		url: "/energyStorage",
		method: "POST",
		data,
	});
};

// 汇流柜
export const getGridFlowData = params => {
	return request({
		url: "/grid/flow/data",
		method: "GET",
    params
	});
};
// c8s储能柜
export const getPhotovoltaicsFlowData = params => {
	return request({
		url: "/photovoltaics/flow/data",
		method: "GET",
    params
	});
};
// 充电口
export const getChargeData = params => {
	return request({
		url: "/chargeBill/data",
		method: "GET",
    params
	});
};
// pcs
export const getPCSFlowData = params => {
	return request({
		url: "/pcs/flow/data",
		method: "GET",
    params
	});
};